/* Lamisah collection page: grid views, sort, filter drawer, price slider,
   load more — all updated in place through the Section Rendering API. */
(function () {
  'use strict';

  function qs(sel, el) { return (el || document).querySelector(sel); }
  function qsa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function store(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, val);
    } catch (e) { /* storage blocked: fine */ }
    return null;
  }
  function withSection(url, id) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id);
  }
  function num(n) {
    try { return Number(n).toLocaleString('en-US'); } catch (e) { return String(n); }
  }

  /* card videos added after load (the shared card-fx wires the first batch) */
  function wireVideos(scope) {
    qsa('video.lmsh-cardvid', scope).forEach(function (v) {
      if (v.dataset.lmshWired) return;
      v.dataset.lmshWired = '1';
      var start = parseFloat(v.getAttribute('data-start')) || 0;
      var end = parseFloat(v.getAttribute('data-end')) || 0;
      var host = v.closest('.lm-card') || v.parentElement;
      function toStart() { try { if (start > 0) v.currentTime = start; } catch (e) { /* noop */ } }
      v.addEventListener('timeupdate', function () { if (end > start && v.currentTime >= end) toStart(); });
      function play() {
        v.classList.add('is-on');
        if (v.readyState < 1) v.load();
        toStart();
        var p = v.play();
        if (p && p.catch) p.catch(function () { v.classList.remove('is-on'); });
      }
      function stop() { v.classList.remove('is-on'); try { v.pause(); toStart(); } catch (e) { /* noop */ } }
      if (window.matchMedia('(hover: hover)').matches) {
        host.addEventListener('mouseenter', play);
        host.addEventListener('mouseleave', stop);
      } else {
        host.addEventListener('touchstart', play, { passive: true });
        host.addEventListener('touchend', stop, { passive: true });
      }
    });
  }

  function Plp(el) {
    this.el = el;
    this.id = el.getAttribute('data-section-id');
    var self = this;
    el.classList.add('has-js');

    el.addEventListener('click', function (e) { self.onClick(e); });
    el.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-lm-filter-form]');
      if (!form) return;
      e.preventDefault();
      self.applyForm(form);
    });
    el.addEventListener('input', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-lm-price-step')) return;
      var price = e.target.closest('[data-lm-price]');
      if (price) self.paintPrice(price, e);
    });
    el.addEventListener('change', function (e) {
      var step = e.target.closest && e.target.closest('[data-lm-price-step]');
      if (step) self.pickPriceStep(step);
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-lm-sort]')) self.closeSort();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.closeSort(); });
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.lmPlp) self.render(location.href, false);
    });
    this.setup();
  }

  Plp.prototype.setup = function () {
    var el = this.el;
    var cssD = getComputedStyle(el).getPropertyValue('--cols-d').trim() || '4';
    var cssM = getComputedStyle(el).getPropertyValue('--cols-m').trim() || '2';
    el.setAttribute('data-cols-d', store('lm-cols-d') || cssD);
    el.setAttribute('data-cols-m', store('lm-cols-m') || cssM);
    this.paintViews();
    qsa('[data-lm-price]', el).forEach(this.paintPrice.bind(this));
    wireVideos(el);
    if (window.LM && window.LM.init) window.LM.init(el);
    this.armAuto();
  };

  /* next page loads by itself when the shopper nears the end of the grid; the button stays as a fallback */
  Plp.prototype.armAuto = function () {
    var self = this;
    if (this.el.getAttribute('data-auto-load') === 'false' || !('IntersectionObserver' in window)) return;
    if (this.io) this.io.disconnect();
    var btn = qs('[data-lm-more]', this.el);
    if (!btn) return;
    this.io = new IntersectionObserver(function (list) {
      list.forEach(function (x) {
        if (x.isIntersecting && !self.loading) self.loadMore(x.target, true);
      });
    }, { rootMargin: '0px 0px 900px 0px' });
    this.io.observe(btn);
  };

  Plp.prototype.paintViews = function () {
    var el = this.el;
    var d = el.getAttribute('data-cols-d');
    var m = el.getAttribute('data-cols-m');
    qsa('[data-lm-cols-d]', el).forEach(function (b) {
      var on = b.getAttribute('data-lm-cols-d') === d;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    qsa('[data-lm-cols-m]', el).forEach(function (b) {
      var on = b.getAttribute('data-lm-cols-m') === m;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  Plp.prototype.closeSort = function () {
    var list = qs('[data-lm-sort-list]', this.el);
    var btn = qs('[data-lm-sort-toggle]', this.el);
    if (list && !list.hidden) {
      list.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  };

  Plp.prototype.onClick = function (e) {
    var el = this.el;
    var t;

    if ((t = e.target.closest('[data-lm-cols-d]'))) {
      el.setAttribute('data-cols-d', t.getAttribute('data-lm-cols-d'));
      store('lm-cols-d', t.getAttribute('data-lm-cols-d'));
      this.paintViews();
      return;
    }
    if ((t = e.target.closest('[data-lm-cols-m]'))) {
      el.setAttribute('data-cols-m', t.getAttribute('data-lm-cols-m'));
      store('lm-cols-m', t.getAttribute('data-lm-cols-m'));
      this.paintViews();
      return;
    }
    if ((t = e.target.closest('[data-lm-sort-toggle]'))) {
      var list = qs('[data-lm-sort-list]', el);
      if (list) {
        list.hidden = !list.hidden;
        t.setAttribute('aria-expanded', list.hidden ? 'false' : 'true');
      }
      return;
    }
    if ((t = e.target.closest('[data-sort]'))) {
      e.preventDefault();
      this.closeSort();
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', t.getAttribute('data-sort'));
      u.searchParams.delete('page');
      this.render(u.pathname + u.search);
      return;
    }
    if ((t = e.target.closest('[data-lm-fgroup-toggle]'))) {
      var g = t.closest('[data-lm-fgroup]');
      var open = !g.classList.contains('is-open');
      g.classList.toggle('is-open', open);
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if ((t = e.target.closest('[data-lm-filter-link]'))) {
      e.preventDefault();
      var drawer = t.closest('.lm-drawer');
      if (drawer && window.LM) window.LM.closeDrawer(drawer, true);
      this.render(t.getAttribute('href'));
      return;
    }
    if ((t = e.target.closest('[data-lm-more]'))) {
      e.preventDefault();
      this.loadMore(t);
    }
  };

  Plp.prototype.paintPrice = function (box, e) {
    var min = qs('[data-lm-price-min]', box);
    var max = qs('[data-lm-price-max]', box);
    var fill = qs('[data-lm-price-fill]', box);
    var text = qs('[data-lm-price-text]', box);
    var minIn = qs('[data-lm-price-min-input]', box);
    var maxIn = qs('[data-lm-price-max-input]', box);
    if (!min || !max) return;
    var top = parseInt(box.getAttribute('data-max'), 10) || 0;
    var cur = box.getAttribute('data-currency') || '';
    var a = parseInt(min.value, 10) || 0;
    var b = parseInt(max.value, 10) || 0;
    if (a > b) {
      if (e && e.target === min) { min.value = b; a = b; } else { max.value = a; b = a; }
    }
    var pa = top ? (a / top) * 100 : 0;
    var pb = top ? (b / top) * 100 : 100;
    if (fill) { fill.style.left = pa + '%'; fill.style.width = Math.max(0, pb - pa) + '%'; }
    if (text) text.textContent = a.toFixed(2) + ' — ' + b.toFixed(2);
    if (e) {
      if (minIn) minIn.value = a > 0 ? a : '';
      if (maxIn) maxIn.value = b < top ? b : '';
      /* a dragged slider keeps a range tick only when it still matches it */
      if (e.target === min || e.target === max) {
        qsa('[data-lm-price-step]', box).forEach(function (c) {
          c.checked = parseInt(c.getAttribute('data-min'), 10) === a && Math.min(top, parseInt(c.getAttribute('data-max'), 10)) === b;
        });
      }
    }
  };

  /* price range ticks (0-1999, 2000-3999 ...): one at a time, they move the slider */
  Plp.prototype.pickPriceStep = function (step) {
    var box = step.closest('[data-lm-price]');
    if (!box) return;
    var min = qs('[data-lm-price-min]', box);
    var max = qs('[data-lm-price-max]', box);
    var minIn = qs('[data-lm-price-min-input]', box);
    var maxIn = qs('[data-lm-price-max-input]', box);
    var top = parseInt(box.getAttribute('data-max'), 10) || 0;
    qsa('[data-lm-price-step]', box).forEach(function (c) { if (c !== step) c.checked = false; });
    var a = 0;
    var b = top;
    if (step.checked) {
      a = Math.min(top, parseInt(step.getAttribute('data-min'), 10) || 0);
      b = Math.min(top, parseInt(step.getAttribute('data-max'), 10) || top);
    }
    if (min) min.value = a;
    if (max) max.value = b;
    if (minIn) minIn.value = a > 0 ? a : '';
    if (maxIn) maxIn.value = b < top ? b : '';
    this.paintPrice(box);
  };

  Plp.prototype.applyForm = function (form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var base = (form.getAttribute('action') || window.location.pathname).split('?')[0];
    var url = base + (params.toString() ? '?' + params.toString() : '');
    var drawer = form.closest('.lm-drawer');
    if (drawer && window.LM) window.LM.closeDrawer(drawer, true);
    this.render(url);
  };

  Plp.prototype.render = function (url, push) {
    var self = this;
    var el = this.el;
    el.classList.add('is-loading');
    fetch(withSection(url, this.id), { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var dom = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-lm-plp]', dom);
        if (!fresh) { window.location.href = url; return; }
        el.innerHTML = fresh.innerHTML;
        el.classList.remove('is-loading');
        if (push !== false) window.history.pushState({ lmPlp: true }, '', url);
        self.setup();
        var top = el.getBoundingClientRect().top + window.pageYOffset - 80;
        if (window.pageYOffset > top) window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      })
      .catch(function () { window.location.href = url; });
  };

  Plp.prototype.loadMore = function (btn, auto) {
    var self = this;
    var next = btn.getAttribute('data-next');
    if (!next || this.loading) return;
    this.loading = true;
    btn.classList.add('is-loading');
    fetch(withSection(next, this.id), { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var dom = new DOMParser().parseFromString(html, 'text/html');
        var grid = qs('[data-lm-grid]', self.el);
        var items = qsa('[data-lm-grid] > [data-lm-item]', dom);
        items.forEach(function (it) { grid.appendChild(document.importNode(it, true)); });
        var freshMore = qs('.lm-plp__more', dom);
        var oldMore = qs('.lm-plp__more', self.el);
        if (oldMore) {
          if (freshMore) oldMore.replaceWith(document.importNode(freshMore, true));
          else oldMore.remove();
        }
        wireVideos(grid);
        self.loading = false;
        self.armAuto();
      })
      .catch(function () {
        self.loading = false;
        btn.classList.remove('is-loading');
        if (auto) { if (self.io) self.io.disconnect(); return; }
        window.location.href = next;
      });
  };

  function boot(scope) {
    qsa('[data-lm-plp]', scope).forEach(function (el) {
      if (!el.__lmPlp) el.__lmPlp = new Plp(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
